// Google Analytics Utility Functions
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

// Initialize Google Analytics
export const initializeGA = (measurementId: string) => {
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
    gtag('config', '${measurementId}', {
        page_path: window.location.pathname,
      });
    `;
    document.head.appendChild(script2);
};

// Track page views
export const trackPageView = (path: string, properties?: { [key: string]: any }) => {
  if (window.gtag) {
    window.gtag('event', 'page_view', {
      page_path: path,
      ...properties
    });
  }
};

// Track events with funnel context
export const trackEvent = (
  eventName: string,
  eventParams?: {
    funnel_stage?: string;
    step_name?: string;
    [key: string]: any;
  }
) => {
  if (window.gtag) {
    // If it's a funnel step event, standardize the format
    if (eventName === 'funnel_step' && eventParams?.step_name) {
      window.gtag('event', 'funnel_step', {
        funnel_stage: eventParams.step_name,
        ...eventParams
      });
    } else {
      window.gtag('event', eventName, eventParams);
    }
  }
};

// Track user properties
export const setUserProperties = (properties: { [key: string]: any }) => {
  if (window.gtag) {
    window.gtag('set', 'user_properties', properties);
  }
};

// Track exceptions
export const trackException = (description: string, fatal: boolean = false) => {
  if (window.gtag) {
    window.gtag('event', 'exception', {
      description,
      fatal,
    });
  }
}; 